import "./home.scss";
import React, { useContext, useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Card,
  Container,
  Grid,
  CardContent,
  TextField,
  Button,
  FormHelperText,
} from "@mui/material";
import { PageLayout } from "../../components/page/page-layout";
import { Budget } from "../../components/dashboard/budget";
import { AppsListToolbar } from "../../components/dashboard/apps-list-toolbar";
import { AppsListResults } from "../../components/dashboard/app-list-results";
import { DialogComponent } from "../../components/dialog-component";
import { GlobalContext } from "../../context/Provider";
import getAplications from "../../context/actions/aplications/getAplications";
import SearchIcon from "@mui/icons-material/Search";
import searchGetApplications from "../../services/SearchApplications";

const Home = () => {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const [titleDialog, setTitleDialog] = React.useState("");
  const [bodyDialog, setBodyDialog] = React.useState("");
  const { aplicationsDispatch, aplicationsState } = useContext(GlobalContext);
  const [searchTerm, setSearchTerm] = useState("");
  const [dataTable, setDataTable] = useState([]);
  const [emptyResults, setEmptyResults] = useState("");
  const [error, setError] = useState("")

  const {
    aplications: { data, loading },
  } = aplicationsState;
  

  useEffect(() => {
    getAplications()(aplicationsDispatch);
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    setDataTable(data);
  }, [data]);

  const handleSearch = () => {
    searchGetApplications(searchTerm)
      .then((results) => {
        if (results.length === 0) {
          setEmptyResults(`No se encontraron resultados para: ${searchTerm}`);
        } else {
          setEmptyResults(""); // Limpiar el mensaje cuando hay resultados
        }
        setDataTable(results);
      })
      .catch((error) => {
        console.error("Error:", error);
        setEmptyResults("Error al realizar la búsqueda");
      });
  };

  const executeAction = (action, data) => {
    if (action === "accept-dialog") {
      setOpen(false);
    } else if (action === "desactivar") {
      setTitleDialog("Deshabilitar cliente app");
      setBodyDialog(
        <p>
          ¿Confirma que desea deshabilitar el cliente de app{" "}
          <span style={{ fontWeight: "600" }}>{data.appName}</span>?
        </p>
      );
      setOpen(true);
    } else if (action === "activar") {
      setTitleDialog("Habilitar cliente app");
      setBodyDialog(
        <p>
          ¿Confirma que desea habilitar el cliente de app{" "}
          <span style={{ fontWeight: "600" }}>{data.appName}</span>?
        </p>
      );
      setOpen(true);
    } else if (action === "agregar") {
      navigate("/clients/new");
    } else if (action === "view") {
      navigate(`/clients/${data.id}`);
    }
  };

  const handleInputChange = (event) => {
    const value = event.target.value
    setSearchTerm(value)
    setError(
      value.length === 0 ? "" : value.length < 3 ? "El término de búsqueda debe tener al menos 3 caracteres" : "",
    )
  };

  return (
    <PageLayout>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 2,
        }}
      >
        <Container maxWidth={false}>
          <Box sx={{ my: 3 }}>
            <Grid container spacing={3}>
              <Grid item lg={4} sm={6} xl={4} xs={12}>
                <Budget cantidad={data && data.length > 0 ? data.length : 0} />
              </Grid>
            </Grid>
          </Box>
          <Card
            sx={{
              border: "0.5px solid #dddddd",
              padding: "1px",
              boxShadow: "1px 1px #d5d5d5",
            }}
          >
            <CardContent>
              <AppsListToolbar onClick={executeAction} />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: 1,
                  mb: 2,
                  mt: 4,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    flexWrap: "wrap",
                    width: "100%",
                  }}
                >
                  <TextField
                    label="Buscar"
                    variant="outlined"
                    size="small"
                    value={searchTerm}
                    onChange={handleInputChange}
                    error={!!error}
                    sx={{
                      flex: 1,
                      minWidth: 200,
                      maxWidth: 400,
                    }}
                  />
                  <Button
                    variant="contained"
                    startIcon={<SearchIcon />}
                    onClick={handleSearch}
                    disabled={searchTerm.length < 3}
                    sx={{ whiteSpace: "nowrap" }}
                  >
                    Buscar
                  </Button>
                </Box>
                <Box sx={{height:'16px'}}>
                  {error && <FormHelperText  error>{error}</FormHelperText>}
                </Box>
              </Box>
              <Box sx={{ mt: 4 }}>
                <DialogComponent
                  open={open}
                  handleClose={handleClose}
                  onClick={executeAction}
                  title={titleDialog}
                  description={bodyDialog}
                />
                <AppsListResults
                  clientes={dataTable}
                  onClick={executeAction}
                  loading={loading}
                  emptyResults={emptyResults}
                />
              </Box>
            </CardContent>
          </Card>
        </Container>
      </Box>
    </PageLayout>
  );
};

export default Home;